import { createSlice } from "@reduxjs/toolkit";
import { userLoggedOut } from "./AuthSlice";

const initialState = {
  copings: [],
};

export const CopingSlice = createSlice({
  name: "CopingSlice",
  initialState,
  reducers: {
    setCopings: (state, { payload }) => {
      state.copings = payload;
    },
    setAddCopings: (state, { payload }) => {
      state.copings.push(payload?.coping);
    },
    setDeleteCopings: (state, { payload }) => {
      state.copings = state.copings.filter(
        (coping) => coping._id !== payload._id
      );
    },
    setUpdateCopings: (state, { payload }) => {
      const index = state.copings.findIndex(
        (coping) => coping._id === payload?._id
      );
      if (index !== -1) {
        state.copings[index] = {
          ...state.copings[index],
          ...payload,
        };
      }
    },
    extraReducers: (builder) => {
      builder.addCase(userLoggedOut, () => initialState);
    },
  },
});

export const { setCopings, setAddCopings, setUpdateCopings, setDeleteCopings } =
  CopingSlice.actions;
export default CopingSlice.reducer;
